import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { JwtService } from 'src/app/jwt.service';
import { ClienteManager } from 'src/app/managers/cliente-manager';
import { ConverterCarrinhoManager } from 'src/app/managers/converter-carrinho.manager';
import { ItemManager } from 'src/app/managers/item-manager';
import { SnackbarManager } from 'src/app/managers/snackbar-manager';
import { ItemDetalhado } from 'src/app/persistences/item-detalhado';
import { ItemPedido } from 'src/app/persistences/item-pedido';
import { Preco } from 'src/app/persistences/preco';
import { ConfigService } from 'src/app/services/config.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { CartSingletonService } from 'src/app/singletons/cart-singleton.service';
import { PedidoManager } from 'src/app/managers/pedido-manager';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { ClienteSingletonService } from 'src/app/singletons/cliente-singleton.service';
import { MessageDialogCutomizadoComponent } from '../genericos/message-dialog-cutomizado/message-dialog-cutomizado.component';
import { ContaService } from 'src/app/services/conta.service';

@Component({
  standalone: false,
  selector: 'app-lanca-item-cabecalho',
  templateUrl: './lanca-item-cabecalho.component.html',
  styleUrls: ['./lanca-item-cabecalho.component.css']
})
export class LancaItemCabecalhoComponent implements OnInit, OnChanges {
  public exibeEstoque: boolean;
  private subscription: Subscription;
  @Input()
  public itemDetalhado: ItemDetalhado;
  @Output()
  public addItem = new EventEmitter<ItemDetalhado>();
  @Output()
  public addItemCarrinho = new EventEmitter<ItemDetalhado>();

  public apresentaEstoqueOutrasFiliais = false;
  public temWhatsapp = false;
  public whatsapp: string;
  public itemNoCarrinho = false;
  private previewInitialized = false;

  constructor(
    private cartSingletonService: CartSingletonService,
    public itemManager: ItemManager,
    private configService: ConfigService,
    public dialog: MatDialog,
    private pedidoService: PedidoService,
    private snackBarManager: SnackbarManager,
    private jwtService: JwtService,
    private clienteManager: ClienteManager,
    private converterCarrinhoManager: ConverterCarrinhoManager,
    private pedidoManager: PedidoManager,
    private clienteSingletonService: ClienteSingletonService,
    private contaService: ContaService
  ) {
  }

  ngOnInit(): void {
    if(this.configService.getConfig().getApresentaEstoqueDisponivelOutrasFiliais === "S"){
      this.apresentaEstoqueOutrasFiliais = true;
    }
    this.contaService.getContatos().subscribe((contato)=>{
      this.temWhatsapp = contato.flWhatsapp;
      this.whatsapp = contato.celularComercial;
    })
    this.configuraItem();
    this.exibeEstoque = this.configService.getConfig().getExibeEstoque;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['itemDetalhado'] && !changes['itemDetalhado'].firstChange) {
      this.itemNoCarrinho = this.cartSingletonService.itemEstaNoCarrinho(this.itemDetalhado);
      this.previewInitialized = false;
      if (this.itemNoCarrinho) {
        // Chamado #74296: similar/relacionado que já está no carrinho assume a unidade/tabela gravadas no pedido
        // sem esperar o próximo evento do carrinho (configuraItem).
        const itemCarrinho = this.cartSingletonService.getCarrinhoEstatico().getItensCarrinho
          .find(item => item.itemPedido.idItem === this.itemDetalhado.itemPedido.idItem);
        if (itemCarrinho) {
          this.itemDetalhado.itemPedido = itemCarrinho.itemPedido;
        }
      }
    }
  }

  ngOnDestroy() {
		this.subscription.unsubscribe();
	}

  receberQuantidadeInput(quantidade: number) {
    this.itemDetalhado.itemNovo = (this.itemDetalhado.itemPedido.quantidade === null) 
                                  || (this.itemDetalhado.itemPedido.quantidade === undefined) 
                                  || (this.itemDetalhado.itemPedido.quantidade <= 0);
    this.itemDetalhado.itemPedido.quantidade = quantidade;
    this.pedidoManager.gravarItemCarrinhoPedido(this.itemDetalhado)
    .catch((error: HttpErrorResponse) => {
      this.snackBarManager.openSnackBarErro(error, 'Não foi possível salvar o item no carrinho.', 'Ok', 3000);
    });
  }

  configuraItem() {
    this.subscription = this.cartSingletonService.getCarrinhoObservable().subscribe(carrinho => {
      const item = carrinho.getItensCarrinho.find(item => {
        return this.itemDetalhado.itemPedido.idItem === item.itemPedido.idItem
      });
      const wasInCart = this.itemNoCarrinho;
      this.itemNoCarrinho = item !== undefined;
      if (item === undefined) {
        if (!this.previewInitialized || wasInCart) {
          const shouldReset = wasInCart
            || !this.itemDetalhado.itemPedido.idTabelaPreco
            || this.itemDetalhado.itemPedido.quantidade <= 0;
          if (shouldReset) {
            const unMedVenda = this.itemDetalhado.itemPedido.unMedVenda || this.itemDetalhado.itemDetalhes.unMedVendaPadrao;
            const primeiraTier = this.itemDetalhado.itemDetalhes.outrosPrecos
              .filter(p => p.unMedida === unMedVenda && p.qtMinima > 0)
              .sort((a, b) => a.qtMinima - b.qtMinima)[0];
            if (primeiraTier) {
              this.itemDetalhado.itemPedido.idTabelaPreco = primeiraTier.idGeral;
            }
            this.itemDetalhado.itemPedido.quantidade = this.itemManager.getMinimo(this.itemDetalhado).minimo;
            this.itemManager.getValor(this.itemDetalhado).then();
          }
          this.previewInitialized = true;
        }
      } else {
        this.itemDetalhado.itemPedido = item.itemPedido;
        this.previewInitialized = false;
      }
    });
  }

  get itemComercializavel(): boolean {
    return this.itemDetalhado.itemDetalhes.estoqueDisponivel === true && this.itemDetalhado.itemDetalhes.qtDisponivel > 0;
  }

  get produtoAtivo(): boolean {
    return this.itemDetalhado.itemDetalhes.flAtivo === 'S';
  }

  get podeConsultarEstoqueOutraFilial(): boolean {
    return this.produtoAtivo
      && this.apresentaEstoqueOutrasFiliais
      && this.itemDetalhado.itemDetalhes.estoqueOutrasFiliais.length > 0;
  }

  temEstoque(): boolean {
    const bool = true;
    if (!this.itemComercializavel || this.itemDetalhado.itemPedido.quantidade <= 0) {
      return !bool;
    }
    return bool;
  }

  adicionarItemAoCarrinho() {
    if(this.podeConsultarEstoqueOutraFilial && (!this.itemComercializavel || this.itemDetalhado.itemPedido.preco <=0)){
      if (this.apresentaEstoqueOutrasFiliais && this.temWhatsapp && this.whatsapp) {
        const whatsappLink = `https://wa.me/${this.whatsapp}`;
        window.open(whatsappLink, '_blank');
      }
      const dialogRef = this.dialog.open(MessageDialogCutomizadoComponent, {
        width: 'auto',
        height: 'auto',
        data: { message: "Item possui estoque disponível em outra filial! Entre em contato com seu vendedor!" }
      });
      dialogRef.afterClosed().subscribe();      
    }else{
      if (this.clienteManager.validarClienteVendedor()) {
        if (this.temEstoque()) {
          this.itemDetalhado.itemNovo = (this.itemDetalhado.itemPedido.quantidade === null) 
                                        || (this.itemDetalhado.itemPedido.quantidade === undefined) 
                                        || (this.itemDetalhado.itemPedido.quantidade <= 0);
          this.pedidoManager.gravarItemCarrinhoPedido(this.itemDetalhado)
          .then((status) => status && this.snackBarManager.openSnackBar("Item adicionado no carrinho.", "Ok", 2000));
        } else {
          this.itemDetalhado.itemPedido.quantidade <= 0 ? this.snackBarManager.openSnackBar("QUANTIDADE (UN) TEM QUE SER MAIOR QUE 0", 'OK', 2000) :
            this.snackBarManager.openSnackBar("NÃO HÁ ESTOQUE PARA ESTE PRODUTO", 'OK', 2000)
        }
      }
    }
  }

  async getTabelaPrecoEmitter(tabelaPreco: Preco) {
    // Chamado #74296: item com unidade de venda bloqueada fica sem tabela de preço; só pode ser excluído.
    if (this.itemManager.isUnidadeVendaIndisponivel(this.itemDetalhado)) {
      return;
    }
    if (tabelaPreco !== null) {
      this.itemManager.selecionarTabelaDePrecoDoItem(tabelaPreco, this.itemDetalhado);
      await this.itemManager.getValor(this.itemDetalhado);
      this.itemManager.atualizarTabelaDePrecoDoItem(this.itemDetalhado);
    }
  }

  atualizarPrecoItem(itemPedido: ItemPedido) {
    let total = this.itemDetalhado.itemPedido.valorLiquidoIpiSt * this.itemDetalhado.itemPedido.quantidade;
    total = total + (total * this.clienteSingletonService.getClienteEstatico().getPcMarkup)/100;
    this.itemDetalhado.itemPedido.unMedVenda = itemPedido.unMedVenda;
    this.itemDetalhado.itemPedido.idTabelaPreco = itemPedido.idTabelaPreco;
    this.itemDetalhado.itemPedido.quantidade = itemPedido.quantidade !== 0 ? itemPedido.quantidade : 1;
    this.itemDetalhado.itemPedido.vlPrecoTabelaAntigo = this.itemDetalhado.itemPedido.preco;
    this.itemDetalhado.itemPedido.preco = itemPedido.preco;
    this.itemDetalhado.itemPedido.valorLiquido = itemPedido.valorLiquido;
    this.itemDetalhado.itemPedido.valorLiquidoIpiSt = itemPedido.valorLiquidoIpiSt;
    this.itemDetalhado.itemPedido.vlPrecoTabelaNovo = itemPedido.preco;
    this.itemDetalhado.itemPedido.total = total;
  }


}
